import React from 'react';
import SegmentedControl from '../ChallengeWire/SegmentedControl';

export default function InjuryReportScopeTabs({ scope, onChange, meta }) {
	const options = [
		{ value: 'all', label: 'League-wide' },
		{
			value: 'mine',
			label: 'On my rosters',
			badge: meta?.on_roster_count || 0
		}
	];

	return (
		<SegmentedControl
			options={options}
			value={scope}
			onChange={onChange}
			className="w-full sm:w-auto"
		/>
	);
}
